import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ActiveStepDetails from "../components/planPartials/ActiveStepDetails";
import ScrollToTop from "../components/common/ScrollToTop";
import TopStepsStatus from "../components/planPartials/TopStepsStatus";
import ChoosePlan from "../components/planPartials/ChoosePlan";
import { useGeneral } from "../components/contexts/GeneralContext";
import SelectMeals from "../components/planPartials/SelectMeals";
import SignInStep from "../components/planPartials/SignInStep";
import { useStep } from "../components/contexts/SubscriptionContext";
import { useEffect } from "react";

const SubscribeSignInPage = () => {
  const { discountCoupons } = useGeneral();
    const { goToStep } = useStep();
    useEffect(() => {
      goToStep("3");
    }, []);
  return (
    <>
      <ScrollToTop />
      <PageWrapper loading={false} className="">
        <Header code={discountCoupons} />
        <BodyWrapper className="">
          <TopStepsStatus rightText={"Want to Signup?"} url={"/signup?plan"} />
          <div className="pt-4 lg:pt-9">
            <SignInStep />
          </div>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SubscribeSignInPage;
